var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal-base",
    {
      on: {
        "close-modal": function($event) {
          _vm.$emit("close-modal")
          _vm.slowChangeSocial()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "sukima-modal__login__logo__inner",
          attrs: { slot: "icon" },
          slot: "icon"
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "36",
                height: "36",
                viewBox: "0 0 24 24"
              }
            },
            [
              _c("path", {
                staticStyle: { fill: "white" },
                attrs: {
                  d:
                    "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sukima-modal__login__error__text",
          attrs: { slot: "header" },
          slot: "header"
        },
        [
          _vm._v("\n    " + _vm._s(_vm.headerText) + "\n    "),
          _c(
            "a",
            {
              staticClass: "d-inline-block",
              on: {
                click: function($event) {
                  _vm.description = true
                }
              }
            },
            [_c("CommentQuestion")],
            1
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "sukima-modal" } }, [
            _vm.description
              ? _c("div", { staticClass: "login-promotion-modal" }, [
                  _c(
                    "div",
                    [
                      _c("LoginPromotion"),
                      _vm._v(" "),
                      _c("div", { staticClass: "w-100 text-center px-4" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "btn btn-primary rounded-pill btn-block",
                            staticStyle: {
                              "max-width": "400px",
                              margin: "auto",
                              "margin-bottom": "12px",
                              "border-radius": "100px"
                            },
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                _vm.description = false
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              まずはログインしてみよう！\n            "
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "body" }, [
        _vm.isSocialLogin && !_vm.isShowSignUpMerit
          ? _c("div", {
              staticClass: "modal-text",
              domProps: { innerHTML: _vm._s(_vm.bodyText) }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.beforeLoginProvider
          ? _c("div", { staticClass: "modal-text text-danger" }, [
              _vm._v(
                "\n      ※ 前回は" +
                  _vm._s(_vm.beforeLoginProvider) +
                  "でログインしています\n    "
              )
            ])
          : _vm.isShowSignUpMerit
          ? _c(
              "div",
              {
                staticClass: "text-center",
                staticStyle: { "font-size": "14px" }
              },
              [
                _c("div", { staticClass: "pb-2" }, [
                  _vm._v("\n        1分で会員登録してチケットを"),
                  _c("span", { staticClass: "text-danger font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.signupPromotionData.bonusTicket))
                  ]),
                  _vm._v("枚ゲット！\n        "),
                  _c("br"),
                  _c("small", {}, [
                    _vm._v(
                      "※ " +
                        _vm._s(_vm.signupPromotionData.bonusTicket) +
                        "チケットの有効期限は取得から"
                    ),
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v("1週間")
                    ]),
                    _vm._v("です。")
                  ])
                ]),
                _vm._v(" "),
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.signupPromotionData.merit) }
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", [
          _vm.isSocialLogin
            ? _c("div", { staticClass: "modal-join" }, [
                _vm.isVisibleAppDownload
                  ? _c(
                      "a",
                      {
                        staticClass:
                          "modal-join__btn font-weight-bold text-primary w-100 font-size-12px ev-app-install",
                        attrs: {
                          href: _vm.appsDownloadUrl,
                          "data-provider": ""
                        },
                        on: { click: _vm.evWhenDownload }
                      },
                      [
                        _c("span", {
                          staticClass: "modal-join__btn__icon--apps"
                        }),
                        _vm._v("アプリならインストールだけ")
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "modal-join__btn",
                    attrs: { href: "/login/google-oauth2/?next=" + _vm.next },
                    on: {
                      click: function($event) {
                        return _vm.evWhenLogin("google")
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "modal-join__btn__icon--google"
                    }),
                    _vm._v("Googleでログイン")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "modal-join__btn",
                    attrs: { href: "/login/line/?next=" + _vm.next },
                    on: {
                      click: function($event) {
                        return _vm.evWhenLogin("line")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "modal-join__btn__icon--line" }),
                    _vm._v("LINEでログイン")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "modal-join__btn",
                    attrs: { href: "/login/twitter/?next=" + _vm.next },
                    on: {
                      click: function($event) {
                        return _vm.evWhenLogin("twitter")
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "modal-join__btn__icon--twitter"
                    }),
                    _vm._v("Xでログイン")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "modal-join__btn",
                    attrs: { href: "/login/yahoojp/?next=" + _vm.next },
                    on: {
                      click: function($event) {
                        return _vm.evWhenLogin("yahoojp")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "modal-join__btn__icon--yahoo" }),
                    _vm._v("Yahoo!\n          JAPANでログイン")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "modal-join__btn",
                    attrs: { href: "/login/facebook/?next=" + _vm.next },
                    on: {
                      click: function($event) {
                        return _vm.evWhenLogin("facebook")
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "modal-join__btn__icon--facebook"
                    }),
                    _vm._v("Facebookでログイン")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "modal-join__btn",
                    attrs: { href: "/login/mangazenkan/?next=" + _vm.next },
                    on: {
                      click: function($event) {
                        return _vm.evWhenLogin("mangazenkan")
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "modal-join__btn__icon--mangazenkan"
                    }),
                    _vm._v("漫画全巻.comでログイン")
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "modal-join__btn",
                    on: {
                      click: function($event) {
                        _vm.changeIsSocialLogin(false)
                        _vm.evWhenLogin("メール")
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "modal-join__btn__icon--mail" }),
                    _vm._v("メールアドレスでログイン\n        ")
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "text-center mt-3" }, [
            _c(
              "a",
              {
                staticClass: "font-weight-bold",
                attrs: { href: "/signup/?next=" + _vm.next }
              },
              [_vm._v("新規会員登録はこちら")]
            )
          ])
        ]),
        _vm._v(" "),
        !_vm.isSocialLogin
          ? _c(
              "form",
              {
                attrs: {
                  id: "login-required-form",
                  name: "login-required-form",
                  "data-toggle": "validator",
                  autocomplete: "off",
                  action: _vm.loginUrl,
                  method: "post"
                }
              },
              [
                _c("input", {
                  attrs: { type: "hidden", name: "csrfmiddlewaretoken" },
                  domProps: { value: _vm.csrfToken }
                }),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    id: "login-required-next",
                    type: "hidden",
                    name: "next"
                  },
                  domProps: { value: _vm.next }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "joinForm__items" }, [
                  _c("input", {
                    staticClass: "joinForm__items__inputarea",
                    attrs: {
                      id: "login-email",
                      type: "email",
                      onChange: "inputNow(this)",
                      name: "username",
                      "data-error": "メールアドレスを入力してください。",
                      required: ""
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "joinForm__items__label",
                      attrs: { for: "login-email" }
                    },
                    [_vm._v("メールアドレス")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "joinForm__items__border" })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "joinForm__items" }, [
                  _c("input", {
                    staticClass: "joinForm__items__inputarea",
                    attrs: {
                      id: "login-password",
                      type: "password",
                      onChange: "inputNow(this)",
                      name: "password",
                      maxlength: "32",
                      minlength: "8",
                      required: ""
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "joinForm__items__label",
                      attrs: { for: "login-password" }
                    },
                    [_vm._v("パスワード(8文字以上)")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "joinForm__items__border" })
                ]),
                _vm._v(" "),
                !_vm.isMobileapp
                  ? _c(
                      "a",
                      {
                        staticClass: "sukima-modal__login__notice",
                        attrs: { href: "/forgot_password/" }
                      },
                      [_vm._v("パスワードをお忘れですか？")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isSocialLogin
                  ? _c(
                      "div",
                      { staticClass: "sukima-modal__login__footer__inner" },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "sukima-modal__login__footer__confirm js-prevent-loading",
                            attrs: { type: "submit", value: "ログイン" }
                          },
                          [_vm._v("ログイン")]
                        )
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }